import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './CategoryToggle.module.css';

/**
 * Spaces | Services | Jobs tab toggle rendered at the top of the search results area.
 * Switching tabs navigates to /s with the appropriate pub_categoryLevel1 or pub_listingType value
 * while preserving other query params (location, keywords, etc.) where possible.
 *
 * @param {Object} props
 * @param {string|null} props.activeCategory - 'workspaces' | 'services' | 'jobs' | null
 * @param {Function} props.onSwitch - called with the new category/tab value
 */
const CategoryToggle = props => {
  const { activeCategory, onSwitch } = props;

  const tabs = [
    { value: 'workspaces', labelId: 'CategoryToggle.spaces' },
    { value: 'services', labelId: 'CategoryToggle.services' },
    { value: 'jobs', labelId: 'CategoryToggle.jobs' },
  ];

  return (
    <div className={css.root} role="tablist" aria-label="Category">
      {tabs.map(tab => {
        const isActive = activeCategory === tab.value;
        return (
          <button
            key={tab.value}
            role="tab"
            aria-selected={isActive}
            className={classNames(css.tab, { [css.tabActive]: isActive })}
            onClick={() => !isActive && onSwitch(tab.value)}
          >
            <FormattedMessage id={tab.labelId} />
          </button>
        );
      })}
    </div>
  );
};

export default CategoryToggle;
